import React, { useState } from "react";
import "./AdvertiserIdentityMark.css";

/**
 * The advertiser's identity on the public connection page.
 *
 * The logo is an intentional enhancement, never a dependency: the advertiser's
 * NAME is always rendered as real text, and it is the accessible identity of
 * the block. The logo sits beside it and disappears silently when there is
 * none, when the URL is not a usable public image (the server drops anything
 * that is not absolute https), or when the file fails to load at runtime.
 *
 * The image is decorative for that reason — its alt is empty unless the
 * advertiser supplied their own alt text, and the name never disappears behind
 * it. Fetching it is a plain public image request and is not recipient access.
 */
export default function AdvertiserIdentityMark({ name = "", logoUrl = null, logoAlt = null }) {
  const [failed, setFailed] = useState(false);
  const showLogo = Boolean(logoUrl) && !failed;
  const displayName = String(name || "").trim();

  return (
    <div className="ppc-advertiser-identity" data-has-logo={showLogo ? "true" : "false"}>
      {showLogo ? (
        <span className="ppc-advertiser-logo-frame">
          <img
            className="ppc-advertiser-logo"
            src={logoUrl}
            alt={logoAlt || ""}
            aria-hidden={logoAlt ? undefined : "true"}
            loading="lazy"
            decoding="async"
            draggable="false"
            onError={() => setFailed(true)}
          />
        </span>
      ) : null}
      {displayName ? <h2 className="ppc-advertiser-name">{displayName}</h2> : null}
    </div>
  );
}
